import React from 'react';
import { Bar } from '@ant-design/plots';
import { formatCurrency } from '../../utils/formatCurrency';

const BarChartInfringementEnterprise = (props) => {

  const config = {
    data: props.data,
    xField: 'value',
    yField: 'name',
    seriesField: 'name',
    legend: {
      position: 'top-left',
    },
    label: {
      position: 'center',
      style: {
        fill: '#000',
      },
      formatter: (datum) => `${formatCurrency(datum.value)}`,
    },
    padding: 'auto',
    animation: false,
    height: 200,
    autoFit: false,
  };
  return <Bar {...config} />;
};

export default BarChartInfringementEnterprise